import { Address } from '../../models';
import { usersMock } from '../users/users.mock';

const userId = usersMock[0].id;

export const addressesMock: Address[] = [
  {
    alias: 'Mi Casa',
    country: 'Mexico',
    reference: null,
    createdAt: new Date(),
    id: '8nnzue8b4jUsxAGMASLJ',
    municipality: 'Nezahualcóyotl',
    postalCode: '57170',
    province: 'Bosques de Aragón',
    state: 'Estado de México',
    street: 'Angola',
    streetInternalNumber: null,
    streetNumber: '76',
    updatedAt: new Date(),
    userId,
  },
];
